const apiUrl = process.env.REACT_APP_API_URL;

export const fetchMedia = async (token, sortOrder, filters = {}) => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append('sortOrder', sortOrder);

    if (filters.name) queryParams.append('name', filters.name);
    if (filters.category) queryParams.append('category', filters.category);
    if (filters.categoryOperator) queryParams.append('categoryOperator', filters.categoryOperator);
    if (filters.uploadDateStart) queryParams.append('uploadDateStart', filters.uploadDateStart);
    if (filters.uploadDateEnd) queryParams.append('uploadDateEnd', filters.uploadDateEnd);
    if (filters.creationDateStart) queryParams.append('creationDateStart', filters.creationDateStart);
    if (filters.creationDateEnd) queryParams.append('creationDateEnd', filters.creationDateEnd);

    const response = await fetch(`${apiUrl}/images?${queryParams.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch media data');
    }

    const result = await response.json();

    const normalized = (result || []).map((item) => {
      const name = item.originalname || item.name || item.filename || 'unnamed';
      const category = item.category || item.categories || '';
      const uploadDateISO = item.upload_time ? new Date(item.upload_time * 1000).toISOString() : (item.uploadDate || null);
      const creationDateISO = item.created_time ? new Date(item.created_time * 1000).toISOString() : (item.creationDate || null);
      const thumbnailUrl = item.thumbnailUrl || (item.filename && item.upload_time ? `/uploads/${new Date(item.upload_time * 1000).getFullYear()}/${new Date(item.upload_time * 1000).getMonth() + 1}/thumb-${item.filename}` : item.url || '');

      return {
        ...item,
        name,
        category,
        uploadDate: uploadDateISO,
        creationDate: creationDateISO,
        thumbnailUrl,
      };
    });
    return normalized;
  } catch (error) {
    throw error;
  }
};

export const getImageById = async (token, id) => {
  try {
    const response = await fetch(`${apiUrl}/images/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch image by ID');
    }
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const editImage = async (token, id, imageData) => {
  try {
    const response = await fetch(`${apiUrl}/images/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(imageData),
    });
    if (!response.ok) {
      throw new Error('Failed to edit image');
    }
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const addImage = async (token, imageData) => {
  try {
    const response = await fetch(`${apiUrl}/images`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(imageData),
    });
    if (!response.ok) {
      throw new Error('Failed to add image');
    }
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const deleteImage = async (token, id) => {
  try {
    const response = await fetch(`${apiUrl}/images/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to delete image');
    }
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const getImageFileUrl = (id) => {
  return `${apiUrl}/images/file/${id}`;
};

export const getImageThumbnailUrl = (id) => {
  return `${apiUrl}/images/thumbnail/${id}`;
};
